<template>
    <div class="container">
        <!-- <div v-if='courseStatus' class="course_box" @touchmove.prevent>
            <div class="close_btn" @click="canScroll()"></div>
            <div class="course_item">
                <img src="../../assets/img/home/img_pop.png">
                <div class="btn" @click="canScroll()"></div>
            </div>
        </div> -->
        <div class="header">
            <div class="header_back" @click="goBack"></div>
            欢乐即开
            <!-- <div class="header_img"><img src="../../assets/img/home/logo_top.png" alt=""></div> -->
            <!-- <div class="header_img">幸运选号</div> -->
            <!-- <div class="share_con" @click="goToShare">分享</div> -->
        </div>
        <!-- app下载 -->
        <div class="download_con" v-show="download">
            <span @click="closeDownload"></span>
            <span></span>
            <span>幸运天天有，选号不发愁！</span>
            <span @click="downloadFn">下载APP</span>
        </div>
        <!-- 幸运币 -->
        <div class="lucky_currency" :class="[noWechat?'no_wechat':'is_wechat',download?'is_download':'']" style="display:none">
            <router-link tag="div" to="/pay/1" v-if="userId">
                <span :class="userInfo.luckyMoney > 9999?'lucky_money':''">幸运币{{userInfo.luckyNum}}</span>
                <img src="../../assets/img/home/add_money.png" alt="" />
            </router-link>
           <router-link tag="p" to="/loginOrReg" v-else>登录&nbsp;/&nbsp;注册</router-link>
        </div>
        <div class="banner header_top">
           <van-swipe :autoplay="3000">
                <van-swipe-item v-for="(item,index) of bannerList" :key="index">
                    <img :src="item.imgUrl" @click="bannerJump(item.bannerType,item.jumpUrl)" />
                </van-swipe-item>
            </van-swipe>
        </div>
        <div class="item_wrapper">
            <ul class="item_box">
                <router-link to="/latesNews" class="item_con" tag="li">
                    <img src="../../assets/img/home/ic_onebuy01.png" alt="">
                    <p>最新揭晓</p>
                </router-link>
                <router-link :to="userId ? `/buyDetail/${unReciveStatus}` : '/loginOrReg'" class="item_con" tag="li">
                    <img src="../../assets/img/home/ic_onebuy03.png" alt="">
                    <p>参与记录</p>
                    <span class="promrt_num" v-if="userId&&userInfo.unReciveNum>0&&userInfo.unReciveNum<10">{{userInfo.unReciveNum}}</span>
                    <span class="promrt_num promrt_style" v-else-if="userId&&userInfo.unReciveNum>9&&userInfo.unReciveNum<100">{{userInfo.unReciveNum}}</span>
                    <span class="promrt_num promrt_style1" v-else-if="userId&&userInfo.unReciveNum>99">99+</span>
                 </router-link>
                 <router-link :to="userId ?'/luckyMoneyDetail':'/loginOrReg'" class="item_con" tag="li">
                    <img src="../../assets/img/home/ic_onebuy02.png" alt="">
                    <p>幸运币明细</p>
                 </router-link>
                 <li class="item_con">
                    <a href="http://cmsd.caiminbang.net/zcsj/jsj/h5lj/29565554.shtml">
                        <img src="../../assets/img/home/ic_onebuy05.png" alt="">
                        <p>帮助中心</p>
                    </a>
                 </li>
                 <router-link to="/index" class="item_con" tag="li">
                    <img src="../../assets/img/home/ic_onebuy04.png" alt="">
                    <p>个人中心</p>
                 </router-link>
            </ul>
        </div>
        <div class="user_status">
            <div class="has_login" v-if="userId">
                <p>我的幸运币：<span>{{userInfo.luckyMoney}}</span></p>
                <!-- <p v-show="userInfo.luckyMoney<=0">获取后可参与奖品拼抢</p> -->
                <p></p>
                <router-link tag="p" to="/pay/1">获取幸运币</router-link>
                <!-- <router-link tag="p" :to="userId ? `/buyDetail/${unReciveStatus}` : '/loginOrReg'">参与记录 &#62;</router-link> -->

            </div>
            <div class="not_login" v-else>
                <span>参与活动请先登录</span>
                <router-link tag="span" to="/loginOrReg">登录&nbsp;/&nbsp;注册</router-link>
            </div>

        </div>

        <div class="tj_wrapper" style="display:none">
            <van-swipe :loop="false">
                <van-swipe-item v-for="(item,index) of tjList" :key="index">
                    <div class="tj_item">
                        <router-link :to="{path:`/prizeDetail/1/${item[0].issueId}`}" tag="div" class="tj_items">
                            <div class="tj_icon">
                                <!-- <img src="../../assets/img/home/oppo.jpg" alt=""> -->
                                <img :src="item[0].itemUrl" alt="">
                            </div>
                            <p class="prize_name">{{item[0].issueName.length>10?item[0].issueName.substring(0,10)+'...':item[0].issueName}}</p>
                            <p class="prize_info"><span>余{{item[0].itemRemainTimes}}</span>/{{item[0].itemPeotimes}}</p>
                            <div class="action_btn">
                                <span @click.stop="justNowFn(item[0].issueId,item[0].itemPeotimes,item[0].itemBought,1)">参与</span>
                                <span @click.stop="justNowFn(item[0].issueId,item[0].itemPeotimes,item[0].itemBought,item[0].itemRemainTimes)">包尾</span>
                            </div>
                        </router-link>
                        <div class="tj_line"></div>
                        <div v-if="item[1]">
                            <router-link v-show="item[1].issueId" :to="{path:`/prizeDetail/1/${item[1].issueId}`}" tag="div" class="tj_items">
                                <div class="tj_icon">
                                    <img :src="item[1].itemUrl" alt="">
                                </div>
                                <p class="prize_name">{{item[1].issueName.length>10?item[1].issueName.substring(0,10)+'...':item[1].issueName}}</p>
                                <p class="prize_info"><span>余{{item[1].itemRemainTimes}}</span>/{{item[1].itemPeotimes}}</p>
                                <div class="action_btn">
                                    <span @click.stop="justNowFn(item[1].issueId,item[1].itemPeotimes,item[1].itemBought,1)">参与</span>
                                    <span @click.stop="justNowFn(item[1].issueId,item[1].itemPeotimes,item[1].itemBought,item[1].itemRemainTimes)">包尾</span>
                                </div>
                            </router-link>
                        </div>

                    </div>
                </van-swipe-item>
            </van-swipe>
        </div>
        <div class="happyNews" style="display:none">
            <div class="happyNews_title"></div>
            <div class="happyNews_con">
                <van-swipe :autoplay="2000" vertical :touchable="false" :height="29" :show-indicators="false">
                    <van-swipe-item v-for="(item,index) of happyNewsList" :key="index">
                        <router-link tag="p" :to="{path:`/prizeDetail/1/${item.issueId}`}" class="item_text ellipsis">恭喜<span>{{item.userName}}</span>第{{item.issueName}}期获得<span>{{item.itemName}}</span></router-link>
                    </van-swipe-item>
                </van-swipe>
            </div>
            <div class="happyNews_icon"></div>
        </div>
        <div class="tab_wrapper">
            <ul class="tabBar" style="display:none">
                <li
                    v-for="(item,index) of tabBarList"
                    :key="index"
                    :class="index == tabBarIndex ? 'tabBar_active':''"
                    @click="tabSwitch(index)"
                >{{item}}</li>
            </ul>
            <div class="list" v-if="dataStatus">
                <list-cell :list="newList" :userId="userId"  @prizeIndex="prizeIndex"></list-cell>
                <div v-show="list.length>0">
                    <div
                        v-if="Number(pageNo) < Number(pageTotal)"
                        class="see_more_bnt"
                        @click="seeMoreData"
                    > 查看更多</div>

                    <div v-else class="data_null">已加载全部</div>
                </div>
                <div v-show="list.length<=0" class="no_data">
                    <img src="../../assets/img/base/no_list.png" alt="">
                    <p>奖品备货中，请稍后......</p>
                </div>
            </div>
            <div class="list" v-show="!dataStatus" style="min-height:1000px"></div>
        </div>
        <div class="loading_box" v-show="loadingStatus">
            <van-loading vertical >加载中...</van-loading>
        </div>
        <!-- 弹出层 -->
        <van-popup
            v-model="popup"
            position="bottom"
            :overlay="true"
            overlay-class="popupBag"
            >
            <join-layer @popupChange="popupChange" :layerInfo="layerInfo"></join-layer>
        </van-popup>
        <share-layer v-if="isShareShow" :browserType="browserType"  @closeShareLayer = 'closeShareLayer'></share-layer>

        <!-- 活动 -->
        <div class="doing_box" v-show="doingStatus">
            <div @click="toPay">
                <span @click.stop="doingClose"></span>
                <!-- <img src="../../assets/img/home/czs_pop@2x.png" alt=""> -->
                <img :src="doingImg" alt="">
            </div>
        </div>
        <!-- 复制地址下载 -->
        <van-popup v-model="copyUrl" class='copy_url'>
            <div class="copy_url_con">
                <p @click="copyUrl = false"></p>
                <p>点击下方复制地址 <br/>然后在浏览器中打开并进行下载 </p>
                <p @click="copyUrlFn">复制地址</p>
            </div>
        </van-popup>
          <!-- 支付后弹层 -->
        <div class="first_tc_box" v-show="payStatus" @touchmove.prevent>
            <div class="f_layer">
                <p class="f_layer_text1 pay_before1">已经完成支付，请点击【支付完成】。 还未安装支付宝客户端，请点击【重新支付】，选择其他支付方式。 </p>
                <p class="f_layer_text2 pay_before2"> <router-link to="/payHelp">支付宝充值遇到问题？点我>></router-link></p>
                <div class="f_btn">
                    <div class="item_btn cancel" @click="renewPay">重新支付</div>
                    <div class="item_btn confirm" @click="payStatusFn">支付完成</div>
                </div>
            </div>
        </div>
        <!-- 查询支付状态-->
        <div class="first_tc_box" v-show="searchPayStatus">
            <div class="f_layer">
                <p class="pay_money pay_money_y">{{rechargeAmount}}</p>
                <p class="cheap_num cheap_num_n giftAmount" v-show="doingStatus&&giftAmount!==0">含赠送幸运币{{giftAmount}}个</p>
                <!-- <p class="cheap_num cheapOrderAmount giftAmount1">幸运号码请前往个人中心中查看</p> -->
                <div class="f_btn">
                    <div class="item_btn confirm" @click="goBackFn">确定</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import listCell from './component/listCell'
import { setInterval, clearInterval, setTimeout } from 'timers';
import LuckyNumPayVue from '../LuckyNumPay/LuckyNumPay.vue';
export default {
    name:'Home',
    components:{
      listCell,
      'shareLayer': () => import ('@/components/common/shareLayer/shareLayer'),
      'joinLayer' :() => import ('@/components/common/joinLayer/joinLayer')
    },
    data(){
      return {
        isShareShow: false, // false 不显示分享层
        browserType: 'shit', // 浏览器类型 仅判断Safari wx Chrome 其余传shit标识
        bannerList:[],
        happyNewsList:[],
        tabBarList:['全部','新品','进度'],
        tabBarIndex:0,
        list:[],
        popup:false,
        userId:'',
        layerInfo:null,
        userInfo:{
            luckyMoney:'--'
        },
        bingType: 0,
        unReciveStatus : 0,//未领取状态 参与记录使用
        pageNo:1,
        pageTotal:1,
        dataStatus: false,
        noWechat: true,
        loadingStatus:false,
        doingStatus:false,
        doingImg:'',
        download:false,
        copyUrl:false,
        courseStatus: false,
        timeId:'-1',
        tjList:[],
        intervalFn:null,
        routerName:'',
        orderId:'',
        payStatus:false,
        newList:[],
        searchPayStatus:false,
        rechargeAmount:'',//充值金额
        giftAmount:''
      }
    },
    methods:{
        /**
         * 支付完成
         */
        goBackFn(){
            this.searchPayStatus = false
        },
        goBack(){
            // this.$router.go(-1)
            if(localStorage.getItem('orderId')){
                localStorage.removeItem('orderId')
            }
            this.$router.push({
                path:'/'
            })
        },
        /**
         * 点击支付完成  查询充值状态
         */
        payStatusFn(){
            let parameter = {
                transactionType: '10230415',
                sysType: 'WTG',
                data: {
                    orderId: this.orderId,
                    userId: this.userId
                }
            }
            this.$post(parameter).then(res => {
                res = res.message.body
                if(res.resCode === '000000'){
                    let message = ''
                    if(res.status === '1'){
                        message = '订单处理中...'
                        this.$toast(message)
                        return
                    }
                    if(res.status === '2'){
                        this.userInfo.luckyMoney = parseInt(res.moneyBalance)
                        this.rechargeAmount = res.message
                        this.giftAmount = parseInt(res.giveMoney)
                        this.payStatus = false
                        this.searchPayStatus = true
                    }
                    if(res.status === '3'){
                        message = '充值失败'

                        Dialog.alert({
                            message: message
                        }).then(() => {

                        });
                    }
                }else if(res.resCode === '3002'){
                    this.closeingStatus = false
                    this.rnewLogin()
                    return
                }else{
                    this.$toast(res.message)
                }
            })
        },
        //重新支付
        renewPay(){
            this.payStatus = false
            let pathName = ''
            if(this.routerName=='pay'){
                pathName = '/pay/1'
            }else{
                pathName = '/LuckyNumPay'
            }
            this.$router.push({
                path: pathName
            })
        },

        //禁止滚动
        stopScroll(){
            let mo=function(e){e.preventDefault()}
            document.body.style.overflow='hidden'
            document.body.style.position='fixed'
            document.body.style.width='100%'
            document.addEventListener("touchmove",mo,false)//禁止页面滑动
        },
        /***取消滑动限制***/
        canScroll(){
            let newDate = (new Date()).getDate()
            this.courseStatus = false
            localStorage.setItem('newDoing', newDate)
            // let mo=function(e){e.preventDefault()}
            // document.body.style.overflow=''//出现滚动条
            // document.body.style.position='initial'
            // document.body.style.height='auto'
            // document.removeEventListener("touchmove",mo,false)
        },
        /**
         * 去分享
         */
        goToShare() {
            if((this.utils.isClient())==1){
                this.utils.clientLink({
                    shareUrl: window.location.origin
                })
            }else{
                this.browserType = this.utils.browserType()
                this.isShareShow = true
            }
        },
        /**
         * 复制下载地址
         */
        copyUrlFn(){
            let _self = this
            this.$copyText('http://xz.xyxh888.cn').then(function (e) {
                _self.$toast({
                    message: '复制成功'
                });
            }, function (e) {
                _self.$toast({
                    message: '复制失败，请手动复制输入'
                });
            });
            this.copyUrl = false
        },
        /**
         * 子组件回调  关闭分享层
         */
        closeShareLayer() {
            this.isShareShow = false
        },
        tabSwitch(i){
            // this.dataStatus = false
            this.tabBarIndex = i
            // this.list = []
            this.pageNo = 1
            this.$router.replace({
                path:`/home/${i}`
            })
            this.getPrizeList()
        },
        /**
         * 弹层组件回调 关闭参与层
         */
        popupChange(i){
            this.popup = i.status
            /**
             * 判断弹层回调类型 1 点击按钮关闭 2 点击提交关闭
             */
            if(i.type===2){
                this.requestjoin(this.layerInfo.id,i.num,1)
            }
        },
        /**
         * 立即参与函数
         */
        requestjoin(i,n,t){
            let that = this
            /**
             * 判断是否绑定手机号
             */
            if(this.bingType!=='1'){
                this.$dialog.confirm({
                    message: '为确保参与活动真实有效，请先<br/>绑定手机后再参与！',
                    confirmButtonText: '去绑定'
                }).then(() => {
                    this.$router.push({
                        path:'/bindPhone'
                    })
                }).catch(() => {

                })
                return
            }
            /**
             * 判断幸运币是否满足参与次数
             */
            if(n>this.userInfo.luckyMoney){
                this.$dialog.confirm({
                    message: '幸运币不足，请获取后再参与！',
                    confirmButtonText: '去获取'
                }).then(() => {
                    this.$router.push({
                        path:'/pay/1'
                    })
                }).catch(() => {

                })
                return
            }
            this.loadingStatus = true
            let parameter = {
                transactionType: '10230306',
                sysType: 'WTG',
                data: {
                    userId: this.layerInfo.userId,
                    type: t+'',
                    valueId: i,
                    timeNumber: n+''
                }
            }
            this.$post(parameter).then(res => {
                setTimeout(()=>{
                    this.loadingStatus = false
                },800)
                res = res.message.body
                if(res.resCode==='000000'){
                    this.userInfo.luckyMoney = parseInt(res.moneyBalance)
                    this.$dialog.alert({
                        message: `您已成功参与<br>请及时关注开奖结果`,
                        confirmButtonText:'知道了'
                    }).then(() => {
                        // that.getTjList()
                        for(let k = 0;k<this.list.length;k++){
                            if(this.list[k].issueId===i){
                                this.list[k].Remain = res.remain
                                this.list[k].bought = Number(this.list[k].total)- res.remain
                                this.list[k].schedule = parseInt((Number(this.list[k].bought))/(Number(this.list[k].total))*100)
                                if(res.remain==='0'){
                                    // this.list = []
                                    this.pageNo = 1
                                    this.getPrizeList()
                                }
                            }
                        }

                    });
                    return
                }
                /**
                 * 该奖品暂无法参与
                 */
                if(res.resCode==='030601'){
                    this.$dialog.alert({
                        message: res.message,
                        confirmButtonText:'知道了'
                    }).then(() => {
                        // on close
                    });
                    return
                }
                /**
                 * 该期人次已满 是否参与最新一期
                 */
                if(res.resCode==='030608'){
                    this.$dialog.confirm({
                        message: res.message
                    }).then(() => {
                        this.requestjoin(res.itemId,n,2)
                        setTimeout(()=>{
                            this.getPrizeList()
                        },500)
                    }).catch(() => {
                        this.getPrizeList()
                    });
                    return
                }
                /**
                 *  剩余幸运码不足
                 */
                if(res.resCode==='030607'){
                    this.$dialog.confirm({
                        message: `该期仅剩${res.remain}人次`,
                        confirmButtonText: '继续参与'
                    }).then(() => {
                        this.requestjoin(this.layerInfo.id,res.remain,1)
                    }).catch(() => {
                         this.getPrizeList()
                    })
                    return
                }
                /**
                 * 幸运币不足，请获取后再参与！
                 */
                if(res.resCode==='030604'){
                    this.$dialog.confirm({
                        message: res.message,
                        confirmButtonText: '去获取'
                    }).then(() => {
                        this.$router.push({
                            path:'/pay/1'
                        })
                    }).catch(() => {

                    })
                    return
                }
                if(res.res!=='000000'){
                     this.$toast(res.message)
                     return
                }
            }).catch((err)=>{
                setTimeout(()=>{
                    this.loadingStatus = false
                    this.$dialog.alert({
                        message: '网络不太顺畅，<br/>请稍后到参与记录中查看参与结果！',
                        confirmButtonText: '确定'
                    })
                },800)
            })
        },

        /**
         * 点击列表立即参与 接收组件回调参数
         */
        prizeIndex(i){
            if(this.loadingStatus){
                return
            }
            this.layerInfo = i
            this.layerInfo.userId = this.userId
            this.popup = true
        },
        /**
         * banner跳转
         */
        bannerJump(t,u){
            if(t==='1'){
                this.$router.push({
                    path:`/prizeDetail/2/${u}`
                })
            }
            if(t==='2'){
                this.$router.push({
                    path:`/${u}`
                })
            }
            if(t==='3' || t==='4'){
                window.location.href = u
            }
        },
        /**
         * 最新中将信息
         */
        getHappyNews(){
            let parameter = {
                transactionType: '10230202',
                sysType: 'WTG',
                data: {
                    pageAmount : '20',
                    timeId : (new Date()).getTime()+''
                }
            }
            this.$post(parameter).then(res => {
                res = res.message.body
                if(res.resCode === '000000'){
                    this.happyNewsList = res.list
                }else{
                    this.$toast(res.message)
                }
            })
        },
        /**
         * 获取奖品列表
         */
        getPrizeList(){
            this.loadingStatus = true
            let parameter = {
                transactionType: '10230201',
                sysType: 'WTG',
                data: {
                    pageAmount: '20',
                    itemTypes: this.tabBarIndex+'',
                    pageNo: this.pageNo+''
                }
            }
            this.$post(parameter).then(res => {
                setTimeout(()=>{
                     this.loadingStatus = false
                     this.dataStatus = true
                },1000)
                res = res.message.body
                if(res.resCode === '000000'){
                    this.pageTotal = res.pageTotal
                    this.processData(res.itemList)
                }else{
                    this.$toast(res.message)
                }
            })

        },
        /**
         * 处理奖品列表
         */
        processData(data){
            let list = []
            for(let i in data){
                let item = data[i]
                let schedule = 0
                schedule = parseInt((Number(item.itemBought))/(Number(item.itemPeotimes))*100)
                if(Number(item.itemBought)>0&&schedule===0){
                    schedule = 1
                }
                let temp = {
                    issueId: item.issueId,//期数id
                    issueName: item.issueName.length>30 ? item.issueName.substring(0,30)+'...':item.issueName,//商品名称
                    prizeId: item.itemId,//商品id
                    prizeImg: item.itemUrl,//商品图片
                    total: parseInt(item.itemPeotimes),//全部
                    bought: parseInt(item.itemBought),//已购买
                    Remain: parseInt(item.itemRemainTimes),//剩余人次
                    schedule: schedule
                }
                list.push(temp)
            }
            if(this.pageNo>1){
                this.list = this.list.concat(list)
            }else{
                this.list = list
            }
            this.newList = this.cutArray(this.list,2)
        },
        /**
         * 分割
         */
        cutArray(array, subLength) {
            let count = 1;
            let newArr = [];
            let resultArr = [];
            array.forEach(function (item) {
                newArr.push(item);
                if (count % subLength == 0) {
                    resultArr.push(newArr);
                    newArr = [];
                }
                if (count % subLength !== 0&&count == array.length) {
                    resultArr.push(newArr);
                }
                count++;
            });
            return resultArr;
        },
        /**
         * 加载更多
         */
        seeMoreData(){
            this.pageNo = this.pageNo+= 1*1
            this.getPrizeList()
        },
        /**
         * banner数据
         */
        getBanner(){
             let parameter = {
                transactionType: '10020806',
                sysType: 'U',
                data: {
                    type : 'wtg_top'
                }
            }
            this.$post(parameter).then(res => {
                let key = Object.keys(res.message.body.datas[0])
                res = res.message.body.datas[0][key].dataList
                this.processBanner(res)
            })
        },
        /**
         * 处理banner数据
         */
        processBanner(data){
            let list = []
            for(let i in data){
                let item = data[i]
                let bannerType = ''
                let jumpUrl= ''
                if(item.url.indexOf('_')!=-1){
                    bannerType= item.url.split('_')[0]
                    jumpUrl= item.url.split('_')[1]
                }else{
                    bannerType= '4'
                    jumpUrl= item.url.split('_')[0]
                }
                let temp = {
                    imgUrl: item.logoFile,
                    bannerType: bannerType,
                    jumpUrl: jumpUrl
                }
                list.push(temp)
            }
            this.bannerList = list
        },
        /**
         * 获取个人信息
         */
        getUserInfo(){
            let parameter = {
                transactionType: '10230406',
                sysType: 'WTG',
                data: {
                    userId : this.userId
                }
            }
            this.$post(parameter).then(res => {
                res = res.message.body
                if(res.resCode === '000000'){
                    this.userInfo = {
                        luckyMoney : String(parseInt(res.bean)),
                        getGiftNums : res.prizedCount,
                        unReciveNum : parseInt(res.unReciveNum)
                    }

                    this.unReciveStatus = this.userInfo.unReciveNum > 0 ? '3' : '0'
                    // if(this.orderId){
                    //     this.payStatusFn()
                    // }
                }else if(res.resCode === '3002'){
                    localStorage.removeItem('jsjUserId')
                    localStorage.removeItem('JSESSIONID')
                    localStorage.removeItem('hrefStr')
                    this.userId = ''
                }else{
                    this.$toast(res.message)
                }
            })
        },
        /**
         * 重新登录
         */
        rnewLogin(){
            this.$dialog.confirm({
                message: '登录超时，请重新登录！',
                confirmButtonText: '去登录'
            }).then(() => {
                this.$router.push({
                    path:'/loginOrReg'
                })
            }).catch(() => {
            })
        },
        /**
         * 活动
         */
        doingClose(){
            let date = (new Date()).getDate()
            localStorage.setItem('doing',date)
            this.doingStatus = false
        },
        /**
         * 活动去支付
         */
        toPay(){
            if(this.userId){
                this.doingClose()
                this.$router.push({
                    path:'/pay/1'
                })
            }else{
                 this.$router.push({
                    path:'/loginOrReg'
                })
            }
        },
        /**
         * 查询活动时间
         */
        doingTime(){
            let that = this
            let parameter = {
                transactionType: '10230501',
                sysType: 'WTG',
                data: {
                    type : '0'
                }
            }
            this.$post(parameter).then(res => {
                res = res.message.body
                if(res.status==='1'){
                    let date = (new Date()).getDate()
                    let day = localStorage.getItem('doing')?localStorage.getItem('doing'):0
                    if(date!==Number(day)){
                        that.doingStatus = true
                    }
                }
            })
        },
        /**
         * 活动弹层
         */
        getDoingImg(){
            let parameter = {
                transactionType: '10020806',
                sysType: 'U',
                data: {
                    type : 'hpage'
                }
            }
            this.$post(parameter).then(res => {
                   let key = Object.keys(res.message.body.datas[0])
                   let doingImg = res.message.body.datas[0][key].dataList[0].logoFile
                   this.doingImg = doingImg
            })
        },
        /*
         * 关闭下载条
         */
        closeDownload(){
            let date = (new Date()).getDate()
            localStorage.setItem('download',date)
            this.download = false
        },
        /**
         * set下载条
         */
        setDownload(){
            if((this.utils.isClient())!==1){
                let date = (new Date()).getDate()
                let localDate = localStorage.getItem('download')?localStorage.getItem('download'):'0'
                if(Number(localDate) === Number(date)){
                    this.download = false
                }else{
                    localStorage.removeItem('download')
                    this.download = true
                }
            }
        },
        /**
         * 立即下载
         */
        downloadFn(){
            if((this.utils.isClient())!==2){
                window.location.href = 'http://xz.xyxh888.cn'
            }else{
                this.copyUrl = true
            }
        },
        /**
         * 获取推荐列表
         */
        getTjList(){
            let parameter = {
                transactionType: '10230207',
                sysType: 'WTG',
                data: {
                    pageAmount: '6',
                    pageNo:'1',
                    itemTypes:'0',
                    timeId:this.timeId
                }
            }
            this.$post(parameter).then(res => {
                res = res.message.body
                this.timeId = res.timeId
                if(res.resCode === '000000'){
                    let tjList = []
                    for(let i = 0; i<res.itemList.length;i+=2){
                        tjList.push(res.itemList.slice(i,i+2))
                    }
                    this.tjList = tjList
                }
            })
        },
         //参与
        justNowFn(i,t,n,j){
            if(this.userId){
                let joinInfo = {
                    id:i,
                    total:t,
                    num:n,
                    joinNum:j
                }
                this.layerInfo = joinInfo
                this.layerInfo.userId = this.userId
                this.popup = true
            }else{
                this.$router.push({
                    path:'/loginOrReg'
                })
            }

        },

        //判断上级路径
        judgePath(){
            let pathName = localStorage.getItem('goBack')
            if(pathName.indexOf('#/LuckyNumPay')!==-1){
                this.routerName = 'LuckyNumPay'
            }
            if(pathName.indexOf('#/pay')!==-1){
                this.routerName = 'pay'
            }
            this.payStatus = true
        }
    },
    watch:{

         $route: {
            handler: function(val, oldVal){
                let loginPath = oldVal.name
                if(loginPath==='loginOrReg'){
                    location.reload()
                }
            }
        }
    },
    mounted(){
        // console.log(localStorage.getItem('courseStatus'))
        // if(!localStorage.getItem('courseStatus')){
        //     this.courseStatus = true
        // }
        let that = this
        this.userId = localStorage.getItem('jsjUserId')
        this.tabBarIndex = this.$route.params.homeType? this.$route.params.homeType:0
        //this.getHappyNews()//最新中将
        this.getBanner()//banner
        this.getPrizeList()//奖品列表
        this.setDownload()//设置下载条
        //this.getTjList()//推荐列表
        // if(this.userId){
        //     this.getUserInfo()
        //     this.bingType = localStorage.getItem('bingtype')?(localStorage.getItem('bingtype')).split('')[0]:'0'
        // }
        //判断微信打开
        if(this.utils.isWxBrowser()||this.utils.isClient()==2){
            this.noWechat = false
        }
        /**
         * 判断上级路径
         */
        // this.orderId = localStorage.getItem('orderId')
        // if(this.orderId){
        //     this.judgePath()
        // }

    },
    activated(){
        // 增加遮罩教程
        let that = this
        // this.orderId = localStorage.getItem('orderId')

        this.payStatus = false

        this.userId = localStorage.getItem('jsjUserId')
        this.tabBarIndex = this.$route.params.homeType? this.$route.params.homeType:0
        this.setDownload()
        if(this.userId){
            this.getUserInfo()
            this.bingType = localStorage.getItem('bingtype')?(localStorage.getItem('bingtype')).split('')[0]:'0'
        }
        this.doingTime()//获取活动状态
        this.getDoingImg()


        let newDate = (new Date()).getDate()
        let newDay = localStorage.getItem('newDoing')?localStorage.getItem('newDoing'):0
        if(newDate!==Number(newDay)){
            that.courseStatus = true
        }
    },
    deactivated(){
        clearInterval(this.intervalFn)
        localStorage.removeItem('orderId')
        localStorage.removeItem('goBack')
    }
}
</script>
<style scoped>
    .container{
        width: 100%;
        overflow: hidden;
        background: #fff;
    }
    .header_top {
        margin-top: 100px;
    }
    .header{
        width: 100%;
        height: 100px;
        overflow: hidden;
        /* background: #FFC016 url('../../assets/img/home/logo_top.png') center no-repeat; */
        background: #FFC016;
        /* background-size: 159px 42px; */
        position: fixed;
        top: 0;
        left: 0;
        z-index: 100;
        line-height: 100px;
        text-align: center;
        color: #671D00;
        font-size: 32px;
    }
    .header_back{
        position: absolute;
        left: 0;
        top: 0;
        width: 50px;
        background: url('../../assets/img/home/img_back.png') center no-repeat;
        background-size: 17px 33px;
        height: 100px;
    }
    /* .header .header_img{
        display: none;
        width: 307px;
        height: 35px;
        float: left;
        margin: 32.5px 0 32.5px 188px;
    } */
    /* .header .header_img img{
        width: 100%;
    }

     .header .share_con{
        width: 105px;
        height: 35px;
        float: right;
        margin: 32.5px 15px 32.5px 0;
        background: url('../../assets/img/home/share_ic.png') 0 center no-repeat;
        background-size: 39px 35px;
        font-size: 31px;
        color: #671D00;
        text-align: right;
        line-height: 35px;
    } */
    .download_con{
        width: 100%;
        height: 70px;
        background: #343434;
        overflow: hidden;
        z-index: 100;
        margin: 100px 0 -100px;
    }
    .download_margin{
        margin-top: 0;
    }
    .download_con span:nth-child(1){
        width: 40px;
        height: 70px;
        background: url('../../assets/img/home/close.png') 0 center no-repeat;
        background-size: 40px;
        margin: 0 10px;
        float: left;
    }
    .download_con span:nth-child(2){
        width: 56px;
        height: 70px;
        background: url('../../assets/img/home/logo.png') 0 center no-repeat;
        background-size: 56px;
        margin-right: 7px;
        float: left;
    }
    .download_con span:nth-child(3){
        height: 70px;
        line-height: 70px;
        font-size: 28px;
        color: #FFFFFF;
        float: left;
    }
    .download_con span:nth-child(4){
        width: 188px;
        height: 70px;
        float: right;
        background:linear-gradient(-13deg,rgba(255,78,43,1),rgba(255,23,62,1));
        font-size: 32px;
        color: #fff;
        text-align: center;
        line-height: 70px;
    }
    .banner{
        width: 100%;
        height: 220px;
        background: #ccc;
    }
    .banner .van-swipe{
        height: 220px;
    }
    .banner img{
        width: 100%;
        height: 220px;
    }
    .item_wrapper{
        width: 100%;
        height: 150px;
        padding: 10px 0;
        background: #f3f3f3;
    }
    .item_box{
        width: 100%;
        overflow: hidden;
        height: 150px;
        display: flex;
        flex-direction: row;
        justify-content : space-around;
        background: #fff;
    }
    .item_box li:nth-child(2){
        position: relative;
    }
    .promrt_num{
        min-width: 35px;
        min-height: 35px;
        position: absolute;

        top: -15px;
        right: 0px;
        font-size: 26px;
        color: #671D00;
        text-align: center;
        line-height: 35px;
        border-radius: 17.5px;
        background: #FFC016;
    }
    .promrt_style{
        padding-left: 15px;
        text-indent: -15px;
    }
    .promrt_style1{
        padding-left: 30px;
        text-indent: -30px;
    }
    .item_con{
        margin-top: 17px;
        text-align: center;
    }
    .item_con img{
        width: 76px;
        height: 76px;
    }
    .item_con p{
        color: #333;
        font-size: 26px;
    }


    .user_status{
        width: 100%;
        height: 88px;
        background: #f3f3f3 url('../../assets/img/home/bag.png') 0 0 no-repeat;
        background-size: 100%;
        overflow: hidden;

    }
    .not_login{
        padding: 0 29px 0 39px;
        line-height: 88px;
        overflow: hidden;

    }
    .not_login span:nth-child(1){
        float: left;
        line-height: 98px;
        text-align: left;
        font-size: 26px;
        color: #2A2A2A;
    }
    .not_login span:nth-child(2){
        float: right;
        width: 195px;
        height: 76px;
        text-align: center;
        color: #fff;
        font-size: 26px;
        line-height: 76px;
        margin: 10px 10px 0 0;
        background: url('../../assets/img/home/btn_to_buy@2x.png') 0 0 no-repeat;
        background-size: 100%;
    }

    .has_login{
        padding: 0 29px 0 39px;
        line-height: 88px;
        overflow: hidden;
    }
    .has_login p:nth-child(1){
        float: left;
        width: 230px;
        /* line-height: 98px; */
        text-align: left;
        font-size: 26px;
        color: #2A2A2A;
        overflow: hidden;
    }
    .has_login p:nth-child(1) span{
        display: inline-block;
        width: 59px;
        line-height: 98px;
        color: #FF173E;
    }
    .has_login p:nth-child(2){
        float: left;
        font-size: 22px;
        color: #8D7A6A;
        line-height: 98px;
    }

    .has_login p:nth-child(3){
        float: right;
        width: 195px;
        height: 76px;
        text-align: center;
        color: #fff;
        font-size: 26px;
        line-height: 76px;
        margin: 10px 10px 0 0;
        background: url('../../assets/img/home/btn_to_buy@2x.png') 0 0 no-repeat;
        background-size: 100%;
        /* letter-spacing: 2px; */
    }
    .has_login p:nth-child(4){
        float: right;
        margin-right: 10px;
        font-size: 26px;
        line-height: 98px;
        font-weight:500;
        color: #FF173E;
    }



    .tj_wrapper{
        width: 100%;
        height: 320px;
        background: #f3f3f3;
        padding-bottom:10px;
    }
    .tj_wrapper .van-swipe{
        height: 320px;
        background: #fff;
    }
    .tj_item{
        width: 100%;
        height: 311px;
        overflow: hidden;
    }
    .tj_line{
        width: 1px;
        float: left;
        height: 190px;
        margin-top: 35px;
        background: #E7E7E7;
    }
    .tj_items{
        width: 374px;
        height: 311px;
        float: left;
    }
    .tj_icon{
        width: 160px;
        height: 160px;
        margin: 15px auto 0;
        text-align: center;
        line-height: 160px;
        position: relative;

    }
    .tj_icon img{
        max-width: 160px;
        max-height: 160px;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        position: absolute;
        margin: auto;
    }

    .prize_name{
        text-align: center;
        font-size: 26px;
        color: #333333;
    }
    .prize_info{
        text-align: center;
        font-size: 20px;
        padding-top: 5px;
        color: #9E9E9E;
    }
    .prize_info span{
        color: #C40004;
    }
    .action_btn{
        width: 220px;
        margin: 5px auto 0;
        overflow: hidden;
    }
    .action_btn span{
        width: 100px;
        height: 50px;
        text-align: center;
        line-height: 50px;
        border-radius: 12px;
        font-size: 26px;
    }
    .action_btn span:nth-child(1){
        float: left;
        background: #FFC016;
        color: #C40004;
    }
     .action_btn span:nth-child(2){
        float: right;
        background: #FF173E;
        color: #fff;
    }





    .list{
        min-height: 300px;
    }
    .happyNews{
        height: 90px;
        overflow: hidden;
        padding: 0 23px 0 27px;
        background: #fff;
    }
    .happyNews_title{
        width: 57px;
        height: 90px;
        background: url('../../assets/img/home/good_mas.png') 0 center no-repeat;
        background-size: 57px 29px;
        float: left;
    }
    .happyNews_con{
        float: left;
        width: 600px;
        height: 29px;
        margin: 30px 0 30px 15px;
        font-size: 26px;
        line-height: 29px;
        overflow: hidden;
    }
    .happyNews_icon{
        float: right;
        width: 12px;
        height: 90px;
        background: url('../../assets/img/home/onebuy_arrow.png') 0 center no-repeat;
        background-size: 12px 21px;
    }
    .item_text{
        color: #9e9e9e;
        font-size: 26px;
    }
    .item_text span:nth-child(1){
        color: #4692f9;
    }
    .item_text span:nth-child(2){
        color: #333;
    }
    .tab_wrapper{
        width: 100%;
        overflow: hidden;
    }
    .tabBar{
        width: 100%;
        height: 60px;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        border-top: 1px solid rgb(204, 204, 204);
        border-bottom: 1px solid rgb(204, 204, 204);
        background: #fff;
    }
    .tabBar li{
        color: #333;
        font-size: 26px;
        height: 60px;
        line-height: 60px;
        /* font-family:HiraginoSansGB-W3; */
        /* font-weight:bold; */
        padding: 0 8px;
        box-sizing: border-box;
    }
    .tabBar .tabBar_active{
        color: #FF173E;
        border-bottom: 5px solid #FF173E;
    }

    .lucky_currency{
        /* width: 250px; */
        width: auto;
        height: 56px;
        line-height: 56px;
        position: fixed;
        left: 0;
        /* top: 110px; */
        background: #FE0E27;
        border-radius: 0 28px 28px 0;
        z-index: 10;
        overflow: hidden;
        padding-right: 10px;
    }
    .no_wechat{
        top: 110px;
    }
    .is_wechat{
        top: 20px;
    }
    .is_download{
        margin-top: 70px;
    }
    .lucky_currency span{
        font-size: 26px;
        color: #fff;
        padding-left: 10px;
        float: left;
    }
    .lucky_currency img{
        width: 46px;
        height: 46px;
        float: left;
        margin: 5px 0 0 10px;
    }

    .lucky_currency p{
        font-size: 26px;
        color: #fff;
        text-align:center;
        padding: 0 15px 0;
    }


    .see_more_bnt{
        width:48%;
        height:70px;
        line-height: 70px;
        text-align: center;
        margin: 30px auto;
        background:#fff;
        border-radius:7px;
    }

    .no_data{
        text-align: center;
        margin: 0 auto;
        padding: 10% 0;
        background: #f3f3f3;
    }
    .no_data img{
        width: 435px;
        height: 331px;
    }
    .no_data p{
        font-size: 32px;
        margin-top: 58px;
        color: #9E9E9E;
    }
    .data_null{
        text-align: center;
        font-size: 26px;
        color: #ccc;
        margin: 20px auto;
    }
    .lucky_currency .lucky_money{
        font-size:20px;
    }

    .loading_box{
        width: 200px;
        height: 200px;
        position: fixed;
        top: 50%;
        left: 50%;
        right: 0;
        bottom: 0;
        margin: -100px 0 0 -100px;
        background: rgba(0, 0, 0, .6);
        border-radius: 10px;
    }
    .van-loading{
        top: 36%;
        left: 38%;
    }

    .doing_box{
        width: 100%;
        height: 100%;
        position: fixed;
        left: 0;
        top: 0;
        background: rgba(0, 0, 0, .7);
        z-index: 100;
    }
    .doing_box div{
        max-width: 684px;
        max-height: 998px;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        position: absolute;
        margin: auto;
    }
    .doing_box div img{
        width: 100%;
    }
    .doing_box div span{
        width: 53px;
        height: 53px;
        position: absolute;
        top: 61px;
        right: 65px;
        background: url('../../assets/img/home/btn_close@3x.png') 0 0 no-repeat;
        background-size: 53px;
    }
    .copy_url{
        width: 650px;
        height: 510px;
        border-radius: 20px;
        /* position: relative; */
    }

    .copy_url_con{
        width: 650px;
        height: 510px;
        position: relative;
        overflow: hidden;
    }
     .copy_url_con p:nth-child(1){
        width: 40px;
        height: 40px;
        background: url('../../assets/img/home/close_pop@2x.png') 0 0 no-repeat;
        background-size: 100%;
        position: absolute;
        top: 28px;
        right: 28px;
    }
    .copy_url_con p:nth-child(2){
        width: 100%;
        margin: 159px 0 112px;
        text-align: center;
        color: #333333;
        font-size: 36px;
    }
    .copy_url_con p:nth-child(3){
        width: 500px;
        height: 90px;
        margin: 0 auto;
        text-align: center;
        line-height: 90px;
        color: #CC0006;
        font-size: 40px;
        border-radius: 20px;
        background: #FFC016;
    }
    .course_box{
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 999999;
        background: rgba(0, 0, 0, .7);
        overflow: scroll;
        -webkit-overflow-scrolling: touch
    }
    .close_btn{
        width: 62px;
        height: 62px;
        position: absolute;
        top: 30%;
        right:25px;
        z-index: 5;
        background: url('../../assets/img/home/close_teach@2x.png') no-repeat;
        background-size: 100% 100%;
    }
    .course_box img{
        width: 100%;
    }
    .course_item .btn{
        width: 264px;
        height: 97px;
        position: absolute;
        bottom: -150px;
        left: 50%;
        margin-left: -132px;
        background: url('../../assets/img/home/btn_liaojie.png') no-repeat;
        background-size: 100% 100%;
    }
    .course_box .course_item{
        position: relative;
        width: 635px;
        height: 798px;
        top: 50%;
        left: 50%;
        margin: -450px 0 0 -317.5px
    }




    .first_tc_box{
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.7)
    }
    .first_tc_box .f_layer{
        position: absolute;
        width:70%;
        height:auto;
        background:rgba(243,243,243,1);
        border-radius:20px;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        padding: 0 6% 3%;
        font-size: 36px;
        color: #333333;
    }
    .f_layer .f_layer_text1{
        margin: 30px 0 20px;
    }
    .f_layer .f_layer_text3{
        font-size: 30px;
        margin: 30px 0 20px;
    }
    .f_layer .f_layer_text4{
        font-size: 26px;
    }
    .f_layer_text5{
        font-size: 30px;
        margin: 30px 0 20px;
        color:red;
    }
    .f_layer .f_layer_text4 span:nth-child(1){
        font-size: 30px;
        color: blue;
    }
    .f_layer .f_layer_text4 span:nth-child(2){
        font-size: 26px;
    }
    .f_layer .f_btn{
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 50px 0 20px;
    }
    .f_layer .f_btn .item_btn{
        width: 240px;
        height: 80px;
        border-radius:20px;
        text-align: center;
        line-height: 80px;
        font-size: 30px;
        color: #333333;
    }
    .f_layer .f_btn .cancel{
        background:rgba(255,255,255,1);
        margin-right: 3%;
    }
    .f_layer .f_btn .confirm{
        background:rgba(255,192,22,1);
        color: #CC0006;
        margin-left: 3%;
    }
    .pay_before1{
        color: #333;
        font-size: 0.875rem;
        padding-top: 1.5625rem;
    }
    .pay_before2 {
        color: #4B8ADF;
        font-size: 0.875rem;
        padding: 0.9375rem 0 0.78125rem;
    }



    .pay_money{
        width: 100%;
        color: #333;
        font-size: 30px;
        padding-top: 100px;
        text-align: center;
        margin-bottom: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/views/home/home.vue